import UITruncateString from 'UIComponents/text/UITruncateString';

// @ts-expect-error ts-migrate FIXME
import { jsx as _jsx } from "react/jsx-runtime";
export default (articles => articles ? articles.get('results')
// @ts-expect-error ts-migrate FIXME
.map(article => ({
  text: article.get('title'),
  value: String(article.get('id')),
  help: /*#__PURE__*/_jsx(UITruncateString, {
    children: article.get('articleSummary')
  }),
  version: article.get('version')
})).toArray() : []);